@if(loader){
<app-loader></app-loader>
}

<p-card>

    <p-dataView #dv [value]="listInvoice" layout="list">

        <ng-template let-listinvoice pTemplate="list">

            <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
                <div class="flex align-items-center">

                    <div>
                        <p-button label="New" (onClick)="create()" class="p-button-outlined" icon="pi pi-plus-circle"
                            size="small" pTooltip="Create Invoice"></p-button>
                        <!-- <p-button (onClick)="deleteInvoice()" *ngIf="selectedOrder && selectedOrder.length > 0" label="Delete"  class="p-button-outlined ml-2" icon="pi pi-trash" severity="danger" size="small"></p-button>
                                <p-button (onClick)="editInvoice()" *ngIf="selectedOrder && selectedOrder.length == 1" label="Edit" class="p-button-outlined ml-2 " icon="pi pi-user-edit" severity="secondary" size="small" ></p-button> -->
                        <!-- <button (click)="generateIRN(order.SalesOrderId)"> Generate e-Invoice</button> -->

                    </div>

                    <div class="flex align-items-center ml-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                                class=" p-inputtext-sm" (keyup.enter)="searchOrder()"
                                style="height: 35px; font-size: 0.875rem; padding-left: 2rem;"
                                autocomplete="one-time-code" />
                        </span>
                        <p-button icon="pi pi-search" (onClick)="searchOrder()"
                            [style]="{'margin': '5px 5px 5px 5px', 'height': '35px', 'line-height': '50px'}"
                            [raised]="true" [size]="'small'" severity="info"></p-button>
                    </div>

                    <!-- <p-button (onClick)="confirmGenerateIRN()" *ngIf="isIRNAllowed" label="Push to IRP"
                        icon="pi pi-check" class="p-button-outlined" size="small" [loading]="isGeneratingIRN"
                        [disabled]="isGeneratingIRN">
                    </p-button>

                    <p-button (onClick)="confirmCancelIRN()" *ngIf="isCancelAllowed" label="Cancel IRN"
                        icon="pi pi-times" class="p-button-outlined ml-2" severity="danger" size="small">
                    </p-button> -->

                    <p-button (onClick)="confirmGenerateIRN()" *ngIf="isEinvoiceEnabled && isIRNAllowed"
                        label="Push to IRP" icon="pi pi-check" class="p-button-outlined" size="small"
                        [loading]="isGeneratingIRN" [disabled]="isGeneratingIRN">
                    </p-button>

                    <p-button (onClick)="confirmCancelIRN()" *ngIf="isEinvoiceEnabled && isCancelAllowed"
                        label="Cancel IRN" icon="pi pi-times" class="p-button-outlined ml-2" severity="danger"
                        size="small">
                    </p-button>


                </div>

                <h2 class="page-title-center">Invoice List</h2>


                <div class="flex">
                    <div class="flex align-items-center">
                        <p-button (onClick)="sendOrderEmail()" label="Send Mail" class="p-button-outlined ml-2"
                            icon="pi pi-envelope" severity="info" size="small"></p-button>
                        <p-button icon="pi pi-refresh" size="small" class="ml-2" (click)="refreshData()"
                            [rounded]="true" severity="info"></p-button>
                    </div>
                </div>

            </div>

            <p-table #dt1 [value]="listInvoice" [scrollable]="true" scrollHeight="613px"
                styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5"
                styleClass="p-datatable-sm " [paginator]="true" [rows]="10" [(selection)]="selectedOrder"
                [globalFilterFields]="['salesOrderNumber','customer.customerName']" [rowsPerPageOptions]="[10 ,15, 20]"
                (onPage)="loadOrderList($event)" [rowHover]="true" [selectionPageOnly]="true">

                <ng-template pTemplate="header">
                    <tr>
                        <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <th>Invoice No</th>
                        <th>Order Date</th>
                        <th>Bill To Customer</th>
                        <!-- <th>Bill To Code </th> -->
                        <th>Ship To Customer</th>
                        <th style="text-align: right;">Order Total </th>
                        <th style="text-align: center;">Invoice Date</th>
                        <th>Status</th>
                        <th *ngIf="isEinvoiceEnabled">IRN Status</th>
                        <th *ngIf="isEinvoiceEnabled">Cancel Status</th>
                        <th>Email Status</th>
                        <th style="text-align: center;">Created By </th>
                        <!-- <th>Delivery Date</th> -->
                        <th>Print </th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-invoice>
                    <tr>
                        <td> <p-tableCheckbox [value]="invoice"></p-tableCheckbox> </td>
                        <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editInvoice(invoice)">
                            {{invoice.salesOrderNumber}}</td>
                        <td>{{invoice.orderDate | date: 'dd/MM/yy'}}</td>
                        <td>{{invoice.customer.customerName}}</td>
                        <!-- <td>{{invoice.billToCustomerCode}}</td> -->
                        <td>{{invoice.shipToCustomerCode}}</td>
                        <td class="text-right"><span>₹ {{ invoice.orderTotal.toLocaleString('en-IN',{
                                minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</span></td>
                        <td style="text-align: center;">{{invoice.salesOrderInvoiceDate | date: 'dd/MM/yy'}}</td>
                        <td [style.color]="paymentStatusColors[invoice.paymentStatus]">{{ invoice.paymentStatus }}</td>
                        <td *ngIf="isEinvoiceEnabled">
                            <span [ngClass]="getEInvoiceStatusClass(invoice)">
                                {{ invoice.eInvoice?.status || 'Not Generated' }}
                            </span>
                        </td>
                        <!-- <td>
                            <span *ngIf="invoice.isCancelExpired" class="expired-badge">
                                Expired
                            </span>

                            <span *ngIf="!invoice.isCancelExpired">
                                Active
                            </span>
                        </td> -->
                        <td *ngIf="isEinvoiceEnabled">
                            <span [ngClass]="getCancelStatusClass(invoice)">
                                {{ getCancelStatus(invoice) }}
                            </span>
                        </td>


                        <!-- <td [style.color]="paymentStatusColors[invoice.status]">{{ invoice.status }}</td> -->
                        <td>
                            <span class="email-badge" [ngClass]="invoice.isEmailSent ? 'sent' : 'not-sent'">
                                {{ invoice.isEmailSent ? 'Sent' : 'Not Sent' }}
                            </span>
                        </td>
                        <td style="text-align: center;">{{invoice.createdBy}}</td>
                        <!-- <td>{{invoice.salesOrderInvoiceDate | date: 'dd/MM/yy'}}</td> -->
                        <td>
                            <span class="pi pi-print" [ngStyle]="{
                                    'color': invoice.paymentStatus === 'Draft' ? '#a9a9a9' : 'rgb(0 35 255)', 
                                    'cursor': invoice.paymentStatus === 'Draft' ? 'not-allowed' : 'pointer'
                                }"
                                (click)="invoice.paymentStatus === 'Draft' ? showDraftAlert() : showReport(invoice)">
                            </span>
                        </td>
                    </tr>
                </ng-template>

            </p-table>

        </ng-template>

    </p-dataView>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

@if(visible){
<p-dialog header="Invoice" [modal]="true" [(visible)]="visible" [style]="{width: '90%', height: '100%'}"
    [draggable]="false" [resizable]="false">

    <stimulsoft-viewer-angular [requestUrl]="path" [action]="'InitViewer'" [width]="'100%'" [height]="'800px'"
        [properties]="properties"></stimulsoft-viewer-angular>

</p-dialog>
}

<p-dialog header="Cancel IRN" [(visible)]="showCancelDialog" [modal]="true" [style]="{width: '400px'}">

    <div class="p-fluid">

        <div class="field text-left">
            <label class="label-required display">Cancel Reason</label>
            <p-dropdown [options]="cancelReasons" [(ngModel)]="selectedCancelReason" optionLabel="label"
                optionValue="value" placeholder="Select Reason" class="w-full"
                [ngClass]="{'ng-invalid ng-dirty': submitted && !selectedCancelReason}">
            </p-dropdown>
            <small *ngIf="submitted && !selectedCancelReason" class="p-error">
                Cancel reason is required
            </small>
        </div>

        <div class="field mt-2 text-left">
            <label class="label-required display">Remark</label>
            <textarea pInputTextarea [(ngModel)]="cancelRemark" rows="3" placeholder="Enter remark..."
                [ngClass]="{'ng-invalid ng-dirty': submitted && !cancelRemark}">
            </textarea>
            <small *ngIf="submitted && !cancelRemark" class="p-error">
                Remark is required
            </small>
        </div>

    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <button pButton label="Cancel" class="p-button-text" (click)="showCancelDialog=false"></button>
            <button pButton label="Submit" class="p-button-danger" (click)="submitCancelIRN()"></button>
        </div>
    </ng-template>

</p-dialog>

<!-- <p-dialog header="Cancel IRN" [(visible)]="showCancelDialog" [modal]="true" [closable]="false"
    [style]="{ width: '420px' }" [breakpoints]="{ '768px': '95vw' }">

    <div class="p-fluid">

        <div class="field mb-4">
            <label class="font-semibold mb-2 block">
                Cancel Reason <span class="text-red-500">*</span>
            </label>

            <p-dropdown [options]="cancelReasons" [(ngModel)]="selectedCancelReason" optionLabel="label"
                optionValue="value" placeholder="Select Reason" class="w-full"
                [ngClass]="{'ng-invalid ng-dirty': submitted && !selectedCancelReason}">
            </p-dropdown>

            <small *ngIf="submitted && !selectedCancelReason" class="p-error">
                Cancel reason is required
            </small>
        </div>

        <div class="field mb-2">
            <span class="p-float-label w-full">
                <textarea pInputTextarea [(ngModel)]="cancelRemark" rows="3" inputId="remark" placeholder=" "
                    class="w-full" [ngClass]="{'ng-invalid ng-dirty': submitted && !cancelRemark}">
                </textarea>

                <label for="remark">
                    Remark <span class="text-red-500">*</span>
                </label>
            </span>

            <small *ngIf="submitted && !cancelRemark" class="p-error">
                Remark is required
            </small>
        </div>

        <small *ngIf="selectedCancelReason === 4" class="text-orange-500">
            Remark is mandatory for "Others"
        </small>

    </div>


    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">

            <button pButton label="Cancel" icon="pi pi-times" class="p-button-text" (click)="onCancelDialogClose()">
            </button>

            <button pButton label="Submit" icon="pi pi-check" class="p-button-danger" (click)="submitCancelIRN()">
            </button>

        </div>
    </ng-template>

</p-dialog> -->